import * as Yup from "yup";

export default () => {
  return Yup.object().shape({
    id: Yup.string().required("common:validator.required"),
    privacyPolicyLink: Yup.string().max(200, "common:validator.max200Chars"),
    privacyPolicyContents: Yup.string(),
    partnerAppKey: Yup.string(),
    partnerAppStoreLink: Yup.string().max(200, "common:validator.max200Chars"),
    partnerPlayStoreLink: Yup.string().max(200, "common:validator.max200Chars"),
    partnerAppPrefix: Yup.string()
      .matches("^[a-z0-9]+$")
      .required("common:validator.required"),
    panelLanguage: Yup.string()
      .max(50, "common:validator.max50Chars")
      .required("common:validator.required"),
    webActive: Yup.boolean(),
    qrcodesActive: Yup.boolean(),
    mobileActive: Yup.boolean(),
    totemActive: Yup.boolean(),
    autocutActive: Yup.boolean(),
    categoriesVisible: Yup.boolean(),
    organizingProducts: Yup.boolean(),
    marketplaceVisible: Yup.boolean(),
    versionsGrouped: Yup.boolean(),
    thumbObjectScale: Yup.number()
      .typeError("common:validator.number")
      .required("common:validator.required"),
    rotationIOS: Yup.number()
      .typeError("common:validator.number")
      .required("common:validator.required"),
    rotationAndroid: Yup.number()
      .typeError("common:validator.number")
      .required("common:validator.required"),
    rotationWeb: Yup.number()
      .typeError("common:validator.number")
      .required("common:validator.required"),
    aspectRatioIOS: Yup.number()
      .typeError("common:validator.number")
      .required("common:validator.required"),
    aspectRatioAndroid: Yup.number()
      .typeError("common:validator.number")
      .required("common:validator.required"),
    aspectRatioWeb: Yup.number()
      .typeError("common:validator.number")
      .required("common:validator.required"),
    positionYIOS: Yup.number()
      .typeError("common:validator.number")
      .required("common:validator.required"),
    positionYAndroid: Yup.number()
      .typeError("common:validator.number")
      .required("common:validator.required"),
    positionYWeb: Yup.number()
      .typeError("common:validator.number")
      .required("common:validator.required"),
    positionZIOS: Yup.number()
      .typeError("common:validator.number")
      .required("common:validator.required"),
    positionZAndroid: Yup.number()
      .typeError("common:validator.number")
      .required("common:validator.required"),
    positionZWeb: Yup.number()
      .typeError("common:validator.number")
      .required("common:validator.required"),
    partnerCurrency: Yup.string().required("common:validator.required"),
    notificationsActive: Yup.string().required("common:validator.required"),
    notificationsLimit: Yup.string()
      .nullable()
      .matches("^[0-9]*$")
      .when("notificationsActive", {
        is: "true",
        then: Yup.string()
          .matches("^[0-9]*$")
          .required("common:validator.required"),
      }),
    notificationsAppId: Yup.string()
      .nullable()
      .max(50)
      .when("notificationsActive", {
        is: "true",
        then: Yup.string().max(50).required("common:validator.required"),
      }),
    notificationsKey: Yup.string()
      .nullable()
      .max(50)
      .when("notificationsActive", {
        is: "true",
        then: Yup.string().max(50).required("common:validator.required"),
      }),
    pdMeasurementActive: Yup.boolean().required("common:validator.required"),
    googleAnalyticsActive: Yup.string().required("common:validator.required"),
    googleAnalyticsKey: Yup.string()
      .nullable()
      .max(50)
      .when("googleAnalyticsActive", {
        is: "true",
        then: Yup.string().max(50).required("common:validator.required"),
      }),
    analyticsDashboardActive: Yup.string().required(
      "common:validator.required"
    ),
    numberOfTotems: Yup.number().required("common:validator.required"),
    webRequestsLimit: Yup.number().required("common:validator.required"),
    partnerTypesNew: Yup.array(),
    partnerTypesDeleted: Yup.array(),
    partnerTypes: Yup.array(Yup.object())
      .min(1, "common:validator.min1Type")
      .required("common:validator.required"),
    effectsCheck: Yup.mixed().test(
      "empty_effect_name",
      "common:validator.emptyEffectName",
      function () {
        const emptyEffects = this.parent.effects?.filter(
          (v) => !v.name || v.name.length === 0
        );
        if (emptyEffects?.length > 0) return false;
        return true;
      }
    ),
  });
};
